import { ProposedDelivery } from '@nuts/auto-delivery-sdk';

export const DEFAULT_DELIVERY_INTERVAL_DAYS = 6 * 7; // 6 weeks
export const DEFAULT_DELIVERY_INTERVAL_WEEKS = DEFAULT_DELIVERY_INTERVAL_DAYS / 7;

export const BASE_AUTO_DELIVERY_PATH = '/account/auto-delivery';

/**
 * Get the minimum interval from subscription list, defaults to {@link DEFAULT_DELIVERY_INTERVAL_DAYS} if not defined
 * @param [format='weeks'] - Format to return the interval in (`days` or `weeks`). Default to `weeks`
 */
export function getProposedDeliveryInterval(
  delivery: ProposedDelivery,
  format: 'days' | 'weeks' = 'weeks',
): number {
  const divisor = format === 'days' ? 1 : 7;
  const intervals = delivery.subscriptions.map((s) => s.interval || DEFAULT_DELIVERY_INTERVAL_DAYS);
  return intervals.length
    ? Math.min(...intervals) / divisor
    : DEFAULT_DELIVERY_INTERVAL_DAYS / divisor;
}
